import React, { useContext, useEffect, useState } from "react";
import $ from "jquery";
import moment from "moment";
import Setting from "./Setting";
import NotificationCenter from "./NotificationCenter";
import MenuIcon from "../../icons/MenuIcon";
import LoaderCircle from "../../loader/LoaderCircle";
import UserPreview from "../menu/UserPreview";
import BackgroundTasks from "../menu/BackgroundTasks";
import CompanyIcon from "../../icons/CompanyIcon";
import SearchGlobal from "./SearchGlobal";
import StringTools from "../../../class/tool/StringTools";
import AuthController from "../../../stories/_auth/Auth/AuthController"
import SessionContext from "../../../context/SessionContext";
import "../../../css/page/Header.css";
import "moment/locale/fr";
moment.locale("fr");

const Header = props => {
    const { setUserAccountForm, setUserPasswordForm, setInformationForm, setSettingForm } = props;
    const { handleSwitch } = useContext(SessionContext);
    const [ showListItems, setShowListItems ] = useState(false);
    const [ switching, setSwitching ] = useState(null);
    const env = JSON.parse(localStorage.getItem("env"));
    const company = JSON.parse(localStorage.getItem("company"));
    const store = JSON.parse(localStorage.getItem("store"));

    const handleInformationForm = () => {
        setInformationForm(true)
    }
    const handleUserAccountForm = () => {
        setUserAccountForm(true);
    }
    const handleUserPasswordForm = () => {
        setUserPasswordForm(true);
    }
    const handleSettingForm = () => {
        setSettingForm(true)
    }
    const handleClickMenuMobile = () => {
        $(".menu").addClass("visible")
    }
    const switchTarget = (target, id) => {
        if (switching !== null)
            return;

        setSwitching({target, id});
        handleSwitch(target, id);
    }
    const displayCompany = () => {
        const companyName = getCompanyName()

        if (companyName !== null && companyName !== "") {
            let okToSwitchCompany = (env.type === "store" && store !== null && AuthController.hasRules(["admin", "accountant", "analyst", "products", "manager", "tech", "skytech"], "company", store.id))

            return <>
                {
                    (switching === null || (switching !== null && (switching.target !== "company" || switching.id !== store.company_id)))
                        ? <CompanyIcon className={"iconEmpire"} onClick={okToSwitchCompany ? () => { switchTarget("company", store.company_id) } : () => {}} />
                        : <LoaderCircle display="loaderSwitchEmpire" strokeWidth="12" stroke="#FFFFFF" />
                }
                <div id="storeCompany" className={"company" + (okToSwitchCompany ? " pointer" : "")} onClick={okToSwitchCompany ? () => { switchTarget("company", store.company_id) } : () => {}}>
                    {
                        (switching === null || (switching !== null && (switching.target !== "company" || switching.id !== store.company_id)))
                            ? <>
                                <CompanyIcon />
                                <p className="name">{companyName}</p>
                            </>
                            : <LoaderCircle display="loader" strokeWidth="12" stroke="#FFFFFF" />
                    }
                </div>
            </>;
        }
    }
    const getCompanyName = () => {
        if (localStorage.getItem("originEnv") === null) return ""
        let environment = JSON.parse(localStorage.getItem("originEnv"))

        switch (environment.type) {
            case "empire":
                for (let i in environment.companies) {
                    if (company !== null && Object.keys(company).length > 0) {
                        if (environment.companies[i].id === company.id)
                            return environment.companies[i].name;
                    }
                    else if (store !== null && Object.keys(store).length > 0) {
                        for (let j in environment.companies[i].stores) {
                            if (environment.companies[i].stores[j].id === store.id) {
                                return environment.companies[i].name;
                            }
                        }
                    }
                    else return "";
                }

                break;
            case "company":
                return environment.name;
            default: break;
        }

        return ""
    }
    const displayArrowMany = () => {
        if (hasManyChilds())
            return <div id="manyArrow" className="many" onClick={ handleClickOnArrow } />
    }
    const hasManyChilds = () => {
        if (env.type === "company") return false;

        let environment = JSON.parse(localStorage.getItem("originEnv"));
        let stores = [];

        try {
            for (let i in environment.companies) {
                for (let j in environment.companies[i].stores)
                    stores.push(environment.companies[i].stores[j]);
            }
        }
        catch (e) {}

        return stores.length > 0;
    }
    const handleClickOnArrow = () => {
        if (!hasManyChilds()) return

        let listStores = "#listStores";
        let storeCompany = "#storeCompany";
        let storeName = "#storeName";
        let menu = "#menu";
        let manyArrow = "#manyArrow";

        if (window.matchMedia('(max-width: 640px)').matches) {
            $(listStores).css("left", "20px");
            $(listStores).css("min-width", $(document).width()-30 + "px");
        }
        else {
            switch (env.type) {
                case "company":
                    $(listStores).css("min-width", ($(storeCompany).outerWidth() + $(manyArrow).outerWidth() + 15) + "px")
                    $(listStores).css("left", $(menu).width() + $(storeCompany).position().left + 5 + "px")

                    break
                case "store":
                    $(listStores).css("min-width", ($(storeName).outerWidth() + $(manyArrow).outerWidth() + 15) + "px")
                    $(listStores).css("left", $(menu).width() + $(storeName).position().left + 5 + "px")

                    break
                default: break
            }
        }

        setShowListItems(!showListItems)
    }
    const buildListEnv = () => {
        if (env.type === "company") return;
        let environment = JSON.parse(localStorage.getItem("originEnv"));
        let storesIn = [];
        let stores = [];

        try {
            let indexCompany = (company !== undefined && company !== null) ? environment.companies.findIndex(_ => _.id === parseInt(company.id)) : -1;

            if (indexCompany >= 0) {
                for (let j in environment.companies[indexCompany].stores)
                    storesIn.push(environment.companies[indexCompany].stores[j]);
            }

            for (let i in environment.companies) {
                if (indexCompany !== undefined && parseInt(i) === parseInt(indexCompany)) continue;

                for (let j in environment.companies[i].stores) {
                    if (environment.companies[i].stores[j].id === env.id) continue;
                    stores.push(environment.companies[i].stores[j]);
                }
            }
        }
        catch (e) {}

        storesIn = sortByName(storesIn);
        stores = sortByName(stores);

        return <>
            {
                storesIn.map((store, index) => (
                    <p key={ index } className={"linkStore" + (env.id === store.id ? " selected" : "")} onClick={ (env.id === store.id ? () => {} : () => { switchTarget("store", store.id) }) }>
                        {
                            (switching === null || (switching !== null && (switching.target !== "store" || switching.id !== store.id)))
                                ? store.shortName !== undefined ? store.shortName : store.name
                                : <LoaderCircle display="loader" strokeWidth="12" stroke="#FFFFFF" />
                        }
                    </p>
                ))
            }
            {
                stores.length > 0
                && <p className={"otherStores"}>Autre{(stores.length > 1 ? "s" : "")} boutique{(stores.length > 1 ? "s" : "")}</p>
            }
            {
                stores.map((store, index) => (
                    <p key={ index } className={"linkStore" + (env.id === store.id ? " selected" : "")} onClick={ (env.id === store.id ? () => {} : () => { switchTarget("store", store.id) }) }>
                        {
                            (switching === null || (switching !== null && (switching.target !== "store" || switching.id !== store.id)))
                                ? store.shortName !== undefined ? store.shortName : store.name
                                : <LoaderCircle display="loader" strokeWidth="12" stroke="#FFFFFF" />
                        }
                    </p>
                ))
            }
        </>;
    }
    const sortByName = list => {
        return list.sort((s1, s2) => {
            if (s1.name > s2.name) return 1;
            else if (s1.name < s2.name) return -1;
            else return 0
        });
    }

    useEffect(() => {
        if (showListItems)
            $("#manyArrow").addClass("opened")
        else
            $("#manyArrow").removeClass("opened")
    }, [showListItems]);

    return (
        <header className="header Header">
            <MenuIcon classname="iconMenuMobile" click={ handleClickMenuMobile } />
            <div className="wrapAccess">
                {
                    displayCompany()
                }
                {
                    (env.type === "store" && store !== null)
                    && <div id="storeName" className="store" onClick={ handleInformationForm }>
                        <p className="name">{ (window.matchMedia('(max-width: 640px)').matches ? StringTools.getFirstChars(store.name) : store.name) }</p>
                    </div>
                }
                <nav id="listStores" className={ "listStores" + (showListItems ? " visible" : "") }>
                    { buildListEnv() }
                </nav>
                { displayArrowMany() }
            </div>
            <UserPreview setAccountForm={handleUserAccountForm} setPasswordForm={handleUserPasswordForm} />
            <div className="containerIcons">
                {
                    /* <SearchGlobal /> */
                }
                <BackgroundTasks />
                <NotificationCenter />
                {
                    (env.type === "store" && AuthController.hasRules(["admin", "tech", "skytech"], env.type, env.id))
                    && <Setting handleClick={ handleSettingForm } />
                }
            </div>
        </header>
    )
}

export default Header;
